<template>
  <v-checkbox v-if="!readOnly && !field.readOnly"
              :ref="inputRef"
              v-model="fieldValue"
              :disabled="field.disabled"
              :hint="field.hint"
              :hide-details="!field.hint"
              :persistent-hint="true"
              :label="label"
              :class="`${field.class} mt-0`"
              @change="fieldChanged" />
  <div v-else :class="{'reg-information': !small, 'reg-information-small': small}">
    <label>{{ field.label }}</label>
    <p>{{ Boolean(fieldValue) ? $t('yes') : $t('no') }}</p>
  </div>
</template>

<script>
import { defineComponent, getCurrentInstance, toRef } from 'vue'
import { useDynamicField } from '../composables/useDynamicField'

export default defineComponent({
  name: 'DynamicCheckbox',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    field: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    box: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    isValidating: {
      type: Boolean,
      default: false
    },
    itemKey: {
      type: String,
      default: ''
    }
  },
  emits: ['input', 'change'],
  setup(props, { emit, expose }) {
    const instance = getCurrentInstance()
    const $t = (key) => instance.proxy.$t(key)

    const {
      fieldValue,
      label,
      fieldChanged,
      inputRef,
      hasError
    } = useDynamicField({
      value: toRef(props, 'value'),
      field: props.field,
      readOnly: props.readOnly,
      isValidating: toRef(props, 'isValidating'),
      itemKey: props.itemKey,
      emptyValue: false,
      emit
    })

    // Initialize with default if provided
    if (props.field.default !== undefined && fieldValue.value === false) {
      fieldValue.value = props.field.default
    }

    // Expose properties for DynamicForm validation
    expose({
      hasError,
      validate: () => inputRef.value?.validate?.()
    })

    return {
      fieldValue,
      label,
      fieldChanged,
      inputRef,
      $t
    }
  }
})
</script>

<style lang="scss">
</style>